import { useApolloClient, useSuspenseQuery } from '@apollo/client';
import GET_NOTIFICATIONS from '@features/notifications/graphql/queries/getNotifications';
import GET_UNREAD_NOTIFICATIONS_COUNT from '@features/notifications/graphql/queries/getUnreadNotificationsCount';
import NOTIFICATION_CREATED from '@features/notifications/graphql/subscriptions/notificationCreated';
import NOTIFICATION_DELETED from '@features/notifications/graphql/subscriptions/notificationDeleted';
import { Notifications } from '@mui/icons-material';
import { Badge, IconButton } from '@mui/material';
import { useEffect, type FC } from 'react';

interface Props {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const PopupButton: FC<Props> = ({ onClick }) => {
  const client = useApolloClient();
  const { data, subscribeToMore } = useSuspenseQuery(GET_UNREAD_NOTIFICATIONS_COUNT);

  useEffect(() => {
    const unsubCreated = subscribeToMore({
      document: NOTIFICATION_CREATED,
      updateQuery(prev) {
        client.refetchQueries({
          include: [GET_NOTIFICATIONS, GET_UNREAD_NOTIFICATIONS_COUNT],
        });
        return prev;
      },
    });
    const unsubDeleted = subscribeToMore({
      document: NOTIFICATION_DELETED,
      updateQuery(prev) {
        client.refetchQueries({
          include: [GET_NOTIFICATIONS, GET_UNREAD_NOTIFICATIONS_COUNT],
        });
        return prev;
      },
    });
    return () => {
      unsubCreated();
      unsubDeleted();
    };
  }, [subscribeToMore, client]);

  return (
    <IconButton onClick={onClick}>
      <Badge badgeContent={data.notificationsConnection.pageInfo.totalCount} color="primary">
        <Notifications />
      </Badge>
    </IconButton>
  );
};
